import { errorNotification } from "Components/MyNotification";
import TelegramApi from "./TelegramApi";

export const getAllUsersToSelectTelegram = async (search) => {
  try {
    const result = await TelegramApi.getAll(1, search);

    if (result.status === "success") {
      return result.dto.data.map((item) => ({
        value: JSON.stringify(item) + `___` + item.id,
        label: item.name,
      }));
    }
    if (result.status === "fail") {
      errorNotification(result.message);
      return [];
    }
    return [];
  } catch (err) {
    errorNotification(err?.message);
    return [];
  }
};

export const getAllWorksToSelectTelegram = async (search, projectId = null) => {
  try {
    const result = await TelegramApi.getAllWorks(1, search, projectId);
    // {
    //   code:'',
    //   code_norm:'',
    //   id:'',
    //   title:'',
    //   unit:'',
    // }
    if (result.status === "success") {
      if (projectId) {
        return result.dto.map((item) => ({
          label: item.code + " " + item.title + ", " + item.unit,
          value:
            JSON.stringify({
              value: 0,
              code: item.code,
              unit: item.unit,
              allowedWorkTypeId: item.id,
              title: item.title,
              materialsForWork: item.materialsForWork
                ? item.materialsForWork.map((el) => {
                    return {
                      id: el.id,
                      value: 0,
                      nomenclature: el.nomenclature,
                      unit: el.unit,
                      dateArrived: el.dateArrived,
                      restCount: el.restCount,
                      restCountAfterChanges: el.restCount,
                      workTypeTied: null,
                    };
                  })
                : null,
            }) +
            "___" +
            item.id,
        }));
      }
    }
    if (result.status === "fail") {
      errorNotification(result.message);
      return [];
    }
    return [];
  } catch (err) {
    errorNotification(err?.message);
    return [];
  }
};

export const getAllMaterialsProjectToSelectTelegram = async (
  search,
  projectId = null,
) => {
  try {
    const result = await TelegramApi.getAllMaterialsForProject(
      1,
      search,
      projectId,
    );

    // {
    //   id:'',
    //   restCount:'',
    //   dateArrived:'',
    //   nomenclature:'',
    //   unit:'',
    // }

    if (result.status === "success") {
      if (projectId) {
        return result.dto.map((item) => ({
          label: `${item.dateArrived} ${item.nomenclature}. Залишок: ${item.restCount} ${item.unit}`,
          value:
            JSON.stringify({
              id: item.id,
              value: 0,
              nomenclature: item.nomenclature,
              unit: item.unit,
              dateArrived: item.dateArrived,
              restCount: item.restCount,
              restCountAfterChanges: item.restCount,
              workTypeTied: item["workTypeTied.id"]
                ? {
                    allowedWorkTypeId: item["workTypeTied.id"],
                    title: item["workTypeTied.title"],
                    code: item["workTypeTied.code"],
                    code_norm: item["workTypeTied.code_norm"],
                    value: 0,
                    comment: "",
                    unit: item["workTypeTied.unit"],
                    connectionWithMaterial:
                      item["workTypeTied.connectionWithMaterial"],
                  }
                : null,
            }) +
            "___" +
            item.id,
        }));
      }
    }
    if (result.status === "fail") {
      errorNotification(result.message);
      return [];
    }
    return [];
  } catch (err) {
    errorNotification(err?.message);
    return [];
  }
};
